import Layout from '../../../layout/Layout'
import HeaderPageSection from 'core/presentation/components/molecules/HeaderPageSection/HeaderPageSection'
import { useParams } from 'react-router-dom'
import PatternEdit from 'components/organisms/PatternEdit/PatternEdit'

export default function EditTemplatePage() {
    const { patternId } = useParams()
    const patternIdNumber = Number(patternId)
    const breadcrumbNavigate = [
        {
            label: 'Plantillas',
            path: '/templates',
        },
        {
            label: 'Editar Plantilla',
            path: '/templates/edit/:id',
        },
    ]

    return (
        <Layout>
            <HeaderPageSection
                title="Editar plantilla"
                showGoBack={false}
                breadcrumbItems={breadcrumbNavigate}
            />
            <PatternEdit patternId={patternIdNumber} />
        </Layout>
    )
}